import { openEditorModal } from '../../../State/editorModal'

export default () => (dispatch) => {

  dispatch(openEditorModal({ newDirectory: true }))

}
